import { render, staticRenderFns } from "./manageGoods.vue?vue&type=template&id=218bec68&scoped=true&"
import script from "./manageGoods.vue?vue&type=script&lang=js&"
export * from "./manageGoods.vue?vue&type=script&lang=js&"
import style0 from "./manageGoods.vue?vue&type=style&index=0&id=218bec68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218bec68",
  null
  
)

export default component.exports